// extracted by mini-css-extract-plugin
module.exports = {"profileIcons":"_profile_icon_list-module--profile-icons--3TzDG"};